export default __webpack_public_path__ + "static/media/15_kitchen.24a4d762.png";